// 通用顶部条组件
const topbar = () => import ("../../layout/topbar");
// 通用主体顶部组件
const AppHeader_Nav = () => import ("../../layout/AppHeader_Navs");
// 通用主体头部组件
const AppHeader_main = () => import ("../../layout/AppHeader_main");
// 通用底部组件
const AppFooter = () => import ("../../layout/AppFooter");
// 当前路由组件
const SellerCenter = () => import('../../views/SellerCenter/index');
export default [
  {
    path: "/SellerCenter",
    name: "SellerCenter",
    components: {
    //   topbar: topbar,
      header: AppHeader_Nav,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
      default: SellerCenter,
    //   footer: AppFooter,
    },
    meta: {
      requireAuth: false, // 需要验证登录状态
    },
    props: {
      header: {
        type: '1',//根据不同类型切入组件判断逻辑
      }
    },
  }
]
